import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { AppointmentsTurnsService } from 'src/app/services/turns-services/appointments-turns-service/appointment-turns.service';
import { Appointment } from 'src/app/models/turns-models/appointment.model';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-turns-dashboard',
  templateUrl: './turns-dashboard.component.html',
  styleUrls: ['./turns-dashboard.component.scss']
})
export class TurnsDashboardComponent implements OnInit, OnDestroy {

  desksStatus;
  reports;
  forms;
  appointments: Array<Appointment>;
  turnAccess: boolean;
  controlsAccess: boolean;
  getDesksStatusSubscription: Subscription;
  getDailyReportsSubscription: Subscription;
  getFormsSubscription: Subscription;
  getDailyAppointmentsSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private reportsTurnsService: ReportsTurnsService,
              private formsTurnsService: FormsTurnsService,
              private appointmentsTurnsService: AppointmentsTurnsService,
              private snackbarService: SnackBarService,
              private userService: UserService,
              private userStorageService: UserStorageService,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
  }

  ngOnInit() {
    this.turnAccess = this.accessGranted('TUR');
    this.controlsAccess = this.accessGranted('CTR');
    this.setBreadcrumb();
    this.getDesksStatus();
    this.getDailyReports();
    this.getForms();
    this.getDailyAppointments();
  }

  private getDesksStatus() {
    if (this.turnAccess) {
      this.getDesksStatusSubscription = this.desksTurnsService.getDesksStatus().subscribe(
        (res) => {
          this.desksStatus = res;
        },
        (error) => {
          this.desksStatus = '-';
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    }
  }

  private getDailyReports() {
    if (this.turnAccess) {
      const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
      const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
      const centerInternalIdList = this.userStorageService.getCenterList().map(center => center.InternalId );
      this.getDailyReportsSubscription = this.reportsTurnsService.filterTurnsList(todayFrom, todayTo, centerInternalIdList, ['ACTIVE', 'INACTIVE', 'DELETED'], null).subscribe(
        (res) => {
          this.reports = res['data']['listTurnStadistics'];
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    }
  }

  private getForms() {
    if (this.turnAccess) {
      this.getFormsSubscription = this.formsTurnsService.getForms().subscribe(
        (res) => {
          this.forms = res;
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    }
  }

  private getDailyAppointments() {
    if (this.turnAccess || this.controlsAccess) {
      const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
      const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
      const centerInternalIdList = this.userStorageService.getCenterList().map( center => center.InternalId );
      this.getDailyAppointmentsSubscription = this.appointmentsTurnsService.getTurnsAppointments(todayFrom, todayTo, centerInternalIdList, null, null, null).subscribe(
        (res: Array<Appointment>) => {
          this.appointments = res;
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    }
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-bookmark', 'turns-page.turns'));
  }

  public accessGranted(accessToken) {
    return this.userService.accessGranted(accessToken);
  }

  ngOnDestroy() {
    if (this.getDesksStatusSubscription) { this.getDesksStatusSubscription.unsubscribe(); }
    if (this.getDailyReportsSubscription) { this.getDailyReportsSubscription.unsubscribe(); }
    if (this.getFormsSubscription) { this.getFormsSubscription.unsubscribe(); }
    if (this.getDailyAppointmentsSubscription) { this.getDailyAppointmentsSubscription.unsubscribe(); }
  }

}
